import * as Dtos from "../dtos/Tmd.dtos";

export const
    LoadProjectedAccrualByTrialId: IProjectedAccrualLoadByTrialIdActionCreator = (trialId) => {
        return {
            type: ACTION_PROJECTEDACCRUAL_LOAD_BY_TRIAL_ID,
            trialId
        }
    },
    LoadProjectedAccrualById: IProjectedAccrualLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_PROJECTEDACCRUAL_LOAD_BY_ID,
            id
        }
    },
    LoadSuccess: IProjectedAccrualLoadSuccessActionCreator = (data, responseStatus) => {
        return {
            type: ACTION_PROJECTEDACCRUAL_LOAD_SUCCESS,
            data,
            responseStatus
        }
    },
    LoadFailure: IProjectedAccrualLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_PROJECTEDACCRUAL_LOAD_FAILURE,
            responseStatus
        }
    },
    SaveProjectedAccrual: IProjectedAccrualSaveActionCreator = (data) => {
        return {
            type: ACTION_PROJECTEDACCRUAL_SAVE,
            data
        }
    },
    SaveSuccess: IProjectedAccrualSaveSuccessActionCreator = (data, responseStatus) => {
        return {
            type: ACTION_PROJECTEDACCRUAL_SAVE_SUCCESS,
            data,
            responseStatus
        }
    },
    SaveFailure: IProjectedAccrualSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_PROJECTEDACCRUAL_SAVE_FAILURE,
            responseStatus
        }
    },
    UpdateProjectedAccrual: IProjectedAccrualUpdateActionCreator = (trialId, data) => {
        return {
            type: ACTION_PROJECTEDACCRUAL_UPDATE,
            trialId,
            data
        }
    },
    UpdateSuccess: IProjectedAccrualUpdateSuccessActionCreator = (data, responseStatus) => {
        return {
            type: ACTION_PROJECTEDACCRUAL_UPDATE_SUCCESS,
            data,
            responseStatus
        }
    },
    UpdateFailure: IProjectedAccrualUpdateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_PROJECTEDACCRUAL_UPDATE_FAILURE,
            responseStatus
        }
    },
    Clear: IProjectedAccrualClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_PROJECTEDACCRUAL_CLEAR,
            propertiesToClear
        }
    };



export const
    ACTION_PROJECTEDACCRUAL_LOAD_BY_TRIAL_ID = "ACTION_PROJECTEDACCRUAL_LOAD_BY_TRIAL_ID",
    ACTION_PROJECTEDACCRUAL_LOAD_BY_ID = "ACTION_PROJECTEDACCRUAL_LOAD_BY_ID",
    ACTION_PROJECTEDACCRUAL_LOAD_SUCCESS = "ACTION_PROJECTEDACCRUAL_LOAD_SUCCESS",
    ACTION_PROJECTEDACCRUAL_LOAD_FAILURE = "ACTION_PROJECTEDACCRUAL_LOAD_FAILURE",

    ACTION_PROJECTEDACCRUAL_SAVE = "ACTION_PROJECTEDACCRUAL_SAVE",
    ACTION_PROJECTEDACCRUAL_SAVE_SUCCESS = "ACTION_PROJECTEDACCRUAL_SAVE_SUCCESS",
    ACTION_PROJECTEDACCRUAL_SAVE_FAILURE = "ACTION_PROJECTEDACCRUAL_SAVE_FAILURE",

    ACTION_PROJECTEDACCRUAL_CREATE = "ACTION_PROJECTEDACCRUAL_CREATE",
    ACTION_PROJECTEDACCRUAL_CREATE_SUCCESS = "ACTION_PROJECTEDACCRUAL_CREATE_SUCCESS",
    ACTION_PROJECTEDACCRUAL_CREATE_FAILURE = "ACTION_PROJECTEDACCRUAL_CREATE_FAILURE",

    ACTION_PROJECTEDACCRUAL_UPDATE = "ACTION_PROJECTEDACCRUAL_UPDATE",
    ACTION_PROJECTEDACCRUAL_UPDATE_SUCCESS = "ACTION_PROJECTEDACCRUAL_UPDATE_SUCCESS",
    ACTION_PROJECTEDACCRUAL_UPDATE_FAILURE = "ACTION_PROJECTEDACCRUAL_UPDATE_FAILURE",

    ACTION_PROJECTEDACCRUAL_CLEAR = "ACTION_PROJECTEDACCRUAL_CLEAR",

    ACTION_PROJECTEDACCRUAL_FILTER = "ACTION_PROJECTEDACCRUAL_FILTER";

export interface IProjectedAccrualLoadByTrialIdAction {
    type: "ACTION_PROJECTEDACCRUAL_LOAD_BY_TRIAL_ID";
    trialId: number;
}

export interface IProjectedAccrualLoadByTrialIdActionCreator {
    (trialId: number): IProjectedAccrualLoadByTrialIdAction;
}

export interface IProjectedAccrualLoadSuccessAction {
    type: "ACTION_PROJECTEDACCRUAL_LOAD_SUCCESS";
    data: Dtos.ProjectedAccrual | Dtos.ProjectedAccrual[];
    responseStatus: Dtos.ResponseStatus;
}

export interface IProjectedAccrualLoadSuccessActionCreator {
    (
        data: Dtos.ProjectedAccrual | Dtos.ProjectedAccrual[],
        responseStatus: Dtos.ResponseStatus
    ): IProjectedAccrualLoadSuccessAction;
}

export interface IProjectedAccrualLoadFailureAction {
    type: "ACTION_PROJECTEDACCRUAL_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface IProjectedAccrualLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IProjectedAccrualLoadFailureAction;
}

export interface IProjectedAccrualLoadByIdAction {
    type: "ACTION_PROJECTEDACCRUAL_LOAD_BY_ID";
    id: number;
}

export interface IProjectedAccrualLoadByIdActionCreator {
    (id: number): IProjectedAccrualLoadByIdAction;
}


export interface IProjectedAccrualSaveAction {
    type: "ACTION_PROJECTEDACCRUAL_SAVE";
    data: Dtos.ProjectedAccrual;

}

export interface IProjectedAccrualSaveActionCreator {
    (
        data: Dtos.ProjectedAccrual
    ): IProjectedAccrualSaveAction;
}

export interface IProjectedAccrualSaveSuccessAction {
    type: "ACTION_PROJECTEDACCRUAL_SAVE_SUCCESS";
    data: Dtos.ProjectedAccrual;
    responseStatus: Dtos.ResponseStatus;
}

export interface IProjectedAccrualSaveSuccessActionCreator {
    (
        data: Dtos.ProjectedAccrual,
        responseStatus: Dtos.ResponseStatus
    ): IProjectedAccrualSaveSuccessAction;
}

export interface IProjectedAccrualSaveFailureAction {
    type: "ACTION_PROJECTEDACCRUAL_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IProjectedAccrualSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IProjectedAccrualSaveFailureAction;
}

export interface IProjectedAccrualUpdateAction {
    type: "ACTION_PROJECTEDACCRUAL_UPDATE";
    trialId: number;
    data: Dtos.ProjectedAccrual[];

}

export interface IProjectedAccrualUpdateActionCreator {
    (
        trialId: number,
        data: Dtos.ProjectedAccrual[]
    ): IProjectedAccrualUpdateAction;
}

export interface IProjectedAccrualUpdateSuccessAction {
    type: "ACTION_PROJECTEDACCRUAL_UPDATE_SUCCESS";
    data: Dtos.ProjectedAccrual[];
    responseStatus: Dtos.ResponseStatus;
}

export interface IProjectedAccrualUpdateSuccessActionCreator {
    (
        data: Dtos.ProjectedAccrual[],
        responseStatus: Dtos.ResponseStatus
    ): IProjectedAccrualUpdateSuccessAction;
}

export interface IProjectedAccrualUpdateFailureAction {
    type: "ACTION_PROJECTEDACCRUAL_UPDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IProjectedAccrualUpdateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IProjectedAccrualUpdateFailureAction;
}

export interface IProjectedAccrualClearAction {
    type: "ACTION_PROJECTEDACCRUAL_CLEAR";
    propertiesToClear?: string[];
}

export interface IProjectedAccrualClearActionCreator {
    (propertiesToClear?: string[]): IProjectedAccrualClearAction;
}

export type ProjectedAccrualAction =
    IProjectedAccrualLoadByTrialIdAction |
    IProjectedAccrualLoadByIdAction |
    IProjectedAccrualLoadFailureAction |
    IProjectedAccrualLoadSuccessAction |
    IProjectedAccrualSaveAction |
    IProjectedAccrualSaveSuccessAction |
    IProjectedAccrualSaveFailureAction |
    IProjectedAccrualUpdateAction |
    IProjectedAccrualUpdateSuccessAction |
    IProjectedAccrualUpdateFailureAction |
    IProjectedAccrualClearAction;
